import React, { Component } from "react";
import Icon from "../../../../components/icon";

import { getLanguageField } from "../../../../utils/language";

export default class Amenities extends Component {
  // state = {
  //   showAlLMenities: false
  // }

  toggleAmenities = () => {
    this.setState({ showAlLMenities: !this.state.showAlLMenities });
  }

  groupAmenities = (amenities) => {
    const groupedAmenities = [];
    amenities.forEach(amenity => {
      if(!amenity.feature_id?.type?.id) return;
      const foundAmenityGroup = groupedAmenities.find(group => group.id === amenity?.feature_id?.type.id);
      if (foundAmenityGroup) {
        groupedAmenities[groupedAmenities.indexOf(foundAmenityGroup)].list.push(getLanguageField(amenity.feature_id.translations, this.props.language, 'name'))
      } else {
        groupedAmenities.push({
          id: amenity.feature_id.type.id,
          title: getLanguageField(amenity.feature_id.type.translations, this.props.language, 'name'),
          list: [getLanguageField(amenity.feature_id.translations, this.props.language, 'name')]
        })
      }
    })
    return groupedAmenities;
  }

  render() {
    const { /*state,*/ props, toggleAmenities, groupAmenities } = this;
    // const { showAlLMenities } = state;
    const { amenities/*, language*/, title = "Amenities", buttonOpenText = "Show less", buttonClosedText = "Show all", buttonStyle } = props;

    const groupedAmenities = groupAmenities(amenities);

    return (
      <div id={title} className="flex flex-col gap-4">
        <h3 className="text-2xl font-bold">{title}</h3>
        {
          groupedAmenities.map((group, idx) => {
            // if (!showAlLMenities && idx > 0) return null;
            return (
              <div key={group.id}>
                <h3 className="text-base font-bold">{group.title}</h3>
                <div className="flex text-sm flex-wrap">
                  {
                    group.list.map((amenity, index) => {
                      return (
                        <p key={`${group.id} - ${index}`} className="w-1/2 flex items-center gap-1 py-2">
                          {group.id !== "5" ? <Icon icon="Check" />  : null}
                          <span>{amenity}</span>
                        </p>
                      )
                    })
                  }
                </div>
              </div>
            )
          })
        }

        {/* {
          groupedAmenities.length > 1
          ?
          <button onClick={toggleAmenities} className={`inline-flex gap-1 border-2 items-center rounded-2xl py-1 px-4 w-fit ${buttonStyle}`}>
            <span className="buttonText">{showAlLMenities ? buttonOpenText : `${buttonClosedText} ${amenities.length}`}</span>
            <Icon icon="ChevronRight" />
          </button>
          : null
        } */}
      </div>
    )
  }
}